export interface Testimonial {
  id: number;
  name: string;
  avatar: string;
  role: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '陈先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20casual%20business%20attire%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '视频创作者',
    content: '这个网站的搜索技巧教程真的帮了大忙！以前经常找不到想要的素材，现在用高级搜索语法几分钟就能精准定位，效率提升了不止一倍。',
    rating: 5,
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '设计师',
    content: '收藏管理那篇教程让我把散乱的收藏夹彻底整理了一遍，现在找灵感素材特别方便。推荐所有设计师都来看看！',
    rating: 5,
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20student%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '大学生',
    content: '作为P站视频新手，入门指南写得特别详细，从注册到各种功能操作都覆盖到了。跟着教程走一遍就完全上手了。',
    rating: 5,
  },
  {
    id: 4,
    name: '张老师',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20middle%20aged%20man%20with%20glasses%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: '在线教育讲师',
    content: '播放列表的学习路径规划思路特别好用，我用它给学生们整理了完整的课程视频序列，教学效果明显提升。',
    rating: 5,
  },
  {
    id: 5,
    name: '刘女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20in%20modern%20office%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    role: '自由职业者',
    content: '下载工具对比测评那篇非常实用，帮我省了不少时间。之前试了好几个工具都不太满意，看了测评直接找到了最适合的。',
    rating: 4,
  },
  {
    id: 6,
    name: '赵先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20with%20confident%20smile%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-06&orientation=squarish',
    role: 'IT工程师',
    content: '隐藏功能那篇文章真是干货满满，用了P站视频两年多了，居然还有这么多不知道的技巧。画中画模式和RSS订阅太好用了。',
    rating: 5,
  },
];